export interface IProps {}

export enum ETabs {
  WPS_FILE = 'WPS_FILE',
  WPS_EXCEPTIONAL_QUEUE = 'WPS_EXCEPTIONAL_QUEUE',
  NON_WPS = 'NON_WPS',
  NON_WPS_EXCEPTION_QUEUE = 'NON_WPS_EXCEPTION_QUEUE',
  NON_WPS_DBT_MANUAL_QUEUE = 'NON_WPS_DBT_MANUAL_QUEUE',
  NEW_NON_WPS = 'NEW_NON_WPS',
  NEW_NON_WPS_EXCEPTION_QUEUE = 'NEW_NON_WPS_EXCEPTION_QUEUE',
  CP_SIF_WPS_FILES = 'CP_SIF_WPS_FILES',
  CP_SIF_EXCEPTIONAL_QUEUE = 'CP_SIF_EXCEPTIONAL_QUEUE'
}
